/*
 * -----------------------------------------------------------------------
 *  <copyright file="add-items-btns/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import Button from '../../core/buttons/button';
import { AddItemsBtnsProps } from './add-items-btns.interface';

const AddItemsBtns = ({
    isSystemAdminLevel,
    canEdit,
    importBtnText,
    importBtnClick,
    addBtnText,
    addBtnClick,
}: AddItemsBtnsProps) => (
    <div className="top-title-btn-wrapper no-mt">
        {isSystemAdminLevel && (
            <Button
                onClick={importBtnClick}
                disabled={!canEdit}
                className="add-cv-btn add-risk-btn main-button import-button"
            >
                {importBtnText}
            </Button>
        )}
        <Button onClick={addBtnClick} disabled={!canEdit} className="main-button">
            {addBtnText}
        </Button>
    </div>
);

export default AddItemsBtns;
